import React from "react";
import $ from "jquery";
import {
  CurrencyRendererRed,
  CurrencyRendererPrice,
  NumberRenderer,
  GetParams,
  DisplayTimeRange,
  MWBaseURL,
  GetESTDateString,
  GetStandardDTButtons,
} from "./../Utilities.js";
import Autocomplete from "react-autocomplete";
import TradeTagsTbl from "./TradeTagsTbl.js";
import { createApiClient } from "../api/ApiClient";

class MultiDayTradesTbl extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      date: null,
      dateEnd: null,
      start: null,
      end: null,
      firm: null,
      acct: null,
      sybl: null,

      needToUpdate: false,
      skipUpdate: false,

      selectedRows: null,

      newTag: "",
      newNote: "",

      displayTagTbl: false,

      groupSymbols: false,
    };

    this.table = null;
    this.symbolcontroller = new AbortController();
    this.taglist = [];
  }

  static getDerivedStateFromProps(props, state) {
    if (
      state.date !== props.date ||
      state.dateEnd !== props.dateEnd ||
      state.firm !== props.firm ||
      state.acct !== props.acct ||
      (props.tag && state.tag !== props.tag) ||
      props.tagAndMode !== state.tagAndMode
    ) {
      return { ...props, needToUpdate: true };
    } else if (
      state.sybl &&
      props.sybl &&
      state.sybl.toString() !== props.sybl.toString()
    ) {
      if (!state.skipUpdate) {
        return { ...props, needToUpdate: true };
      } else {
        return { ...props, skipUpdate: false };
      }
    }
    if (props.autoUpdate && state.updateCount !== props.updateCount) {
      return { ...props, needToUpdate: true };
    }
    return { ...props };
  }

  params() {
    if (this.props.updateSymbols) {
      return this.state;
    } else {
      let tmp = this.state;
      delete tmp.sybl;
      return tmp;
    }
  }

  componentDidUpdate(props, state) {
    let self = this;
    if (this.state.needToUpdate) {
      this.setState({ needToUpdate: false }, function () {
        if (self.table !== null) {
          self.table.clear().draw();
          self.table.ajax
            .url(MWBaseURL() + "multiday_trades?" + GetParams(self.params()))
            .load(null, false);
          self.loadTagList();
        }
      });
    }
  }

  loadTagList() {
    let self = this;

    const apiClient = createApiClient();
    apiClient
      .get(MWBaseURL() + "users_recent_tag_list?" + GetParams(self.params()))
      .then((data) => {
        self.taglist = data;
      });
  }

  componentWillUnmount() {
    $(".popover").popover("dispose");
  }

  getToggleSyblGroupingBtnTxt() {
    if (this.state.groupSymbols) {
      return `Expand <svg class="bi flex-shrink-0" width="16" height="16" role="img" aria-label="Expand symbols"><use xlink:href="#expand-icon"/></svg>`;
    } else {
      return `Collapse <svg class="bi flex-shrink-0" width="16" height="16" role="img" aria-label="Collapse symbols"><use xlink:href="#collapse-icon"/></svg>`;
    }
  }

  async componentDidMount() {
    let self = this;
    const apiClient = createApiClient();
    this.table = $("#tradesTbl").DataTable({
      select: {
        style: "os",
        selector: "td:not(:last-child)",
      },
      dom: "Bfrtip",
      buttons: [
        ...GetStandardDTButtons("Trac P&L Explorer Trades", true),
        {
          text: '<svg class="bi flex-shrink-0" width="16" height="16" role="img" aria-label="Clipboard:"><use xlink:href="#clipboard-icon"/></svg>',
          className: "btn btn-sm btn-secondary",
          init: function (api, node, config) {
            node.removeClass("dt-button");
            node.children(".dt-down-arrow").remove();
          },
          action: function (e, dt, node, config) {
            let tagsLst = [
              ...new Set(
                self.table
                  .rows({ selected: true })
                  .data()
                  .toArray()
                  .map((x) => x.tags.map((i) => i.tag))
                  .flat(),
              ),
            ].join();
            navigator.clipboard.writeText(tagsLst);
          },
        },
        {
          text: self.getToggleSyblGroupingBtnTxt(),
          className: "btn btn-sm btn-secondary",
          init: function (api, node, config) {
            node.removeClass("dt-button");
            node.children(".dt-down-arrow").remove();
          },
          action: function (e, dt, node, config) {
            self.setState(
              { groupSymbols: !self.state.groupSymbols },
              function () {
                node.get(0).innerHTML = self.getToggleSyblGroupingBtnTxt();
                self.tableRefresh();
              },
            );
          },
        },
      ],
      processing: true,
      language: {
        loadingRecords: "&nbsp;",
        processing: "Loading...",
      },
      scrollY: self.props.height + "px",
      scrollX: true,
      responsive: true,
      stateSave: true,
      stateDuration: 0, //infinite
      stateSaveCallback: function (settings, data) {
        // Custom due to conflict in local storage from multiple uses of this component.
        localStorage.setItem(
          "DataTable_tradesTbl_/" + self.props.height,
          JSON.stringify(data),
        );
      },
      stateLoadCallback: function (settings) {
        return JSON.parse(
          localStorage.getItem("DataTable_tradesTbl_/" + self.props.height),
        );
      },
      paging: false,
      info: false,
      ajax: await apiClient.getDataTableAjaxSettings(
        MWBaseURL() + "multiday_trades?" + GetParams(self.state),
        null,
        function (data) {
          if (!self.state.groupSymbols) {
            return data;
          }
          let syblMap = [];
          data.forEach((x) => {
            if (!(x.symbol in syblMap)) {
              syblMap[x.symbol] = {
                symbol: x.symbol,
                start: x.start,
                end: x.end,
                pnl: x.pnl,
                gross_pnl: x.gross_pnl,
                max_pos: x.max_pos,
                max_pos_price: "",
                max_pos_avg_price: "",
                bp_used_at_max: "",
                openPnL: x.openPnL,
                endPnL: x.endPnL,
                tags: x.tags,
                trades: [x],
              };
            } else {
              if (syblMap[x.symbol]["start"] > x.start) {
                syblMap[x.symbol]["start"] = x.start;
                syblMap[x.symbol]["openPnL"] = x.openPnL;
              }
              if (syblMap[x.symbol]["end"] < x.end) {
                syblMap[x.symbol]["end"] = x.end;
                syblMap[x.symbol]["endPnL"] = x.endPnL;
              }
              syblMap[x.symbol]["pnl"] += x.pnl;
              syblMap[x.symbol]["gross_pnl"] += x.gross_pnl;
              syblMap[x.symbol]["max_pos"] = Math.max(
                syblMap[x.symbol]["max_pos"],
                x.max_pos,
              );
              syblMap[x.symbol]["tags"] = syblMap[x.symbol]["tags"].concat(
                x.tags,
              );
              syblMap[x.symbol]["trades"] =
                syblMap[x.symbol]["trades"].concat(x);
            }
          });
          return Object.values(syblMap);
        },
      ),
      order: [[3, "desc"]],
      columns: [
        { title: "Symbol", data: "symbol", className: "symbolInfo" },
        { title: "Start", data: "start", className: "text-nowrap" },
        { title: "End", data: "end", className: "text-nowrap" },
        {
          title: "Net P&L",
          data: "pnl",
          render: CurrencyRendererRed,
          className: "text-right",
        },
        {
          title: "Gross P&L",
          data: "gross_pnl",
          render: CurrencyRendererRed,
          className: "text-right",
        },
        {
          title: "Max Size",
          data: "max_pos",
          render: NumberRenderer,
          className: "text-right",
        },
        {
          title: "Price at Max Size",
          data: "max_pos_price",
          render: CurrencyRendererPrice,
          className: "text-right",
        },
        {
          title: "Avg Price at Max",
          data: "max_pos_avg_price",
          render: CurrencyRendererPrice,
          className: "text-right",
        },
        {
          title: "BP Used at Max",
          data: "bp_used_at_max",
          render: CurrencyRendererRed,
          className: "text-right",
        },
        ...(this.state.date === this.state.dateEnd
          ? [
              {
                title: "P&L at Open",
                data: "openPnL",
                render: CurrencyRendererPrice,
                className: "text-right",
                defaultContent: "",
              },
              {
                title: "P&L at Close",
                data: "endPnL",
                render: CurrencyRendererPrice,
                className: "text-right",
                defaultContent: "",
              },
            ]
          : []),
        {
          title: "Tags",
          data: "tags",
          className: "clickable addTag text-nowrap",
          render: function (data, type, row, meta) {
            if (type === "export") {
              return data.map((x) => x.tag).toString();
            }
            let values = "";
            for (let i in data) {
              if (i >= 2) {
                values += "+" + (data.length - i);
                break;
              } else {
                values +=
                  "<div style='background: #dadada; display: inline; border-radius: 3px; margin:2px'>" +
                  data[i].tag;
                if (data[i].notes) {
                  values += `	<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" class="bi bi-pencil-square" viewBox="0 0 16 16">
												<path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456l-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/>
												<path fill-rule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"/>
											</svg>`;
                }
                values += "</div>";
              }
            }
            return values;
          },
        },
      ],
      columnDefs: [
        {
          targets: [0, 1, 2, this.state.date === this.state.dateEnd ? 10 : 8],
          class: "text-nowrap",
        },
      ],
      rowCallback: function (row, data) {
        let selRows = [];
        let found = false;
        $.each(self.state.selectedRows, function (i, v) {
          if (
            v.symbol === data.symbol &&
            v.start === data.start &&
            v.end === data.end &&
            v.pnl === data.pnl
          ) {
            selRows.push(data);
            found = true;
          } else {
            selRows.push(v);
          }
        });
        if (found) {
          self.setState({ skipEvent: true, skipUpdate: true }, function () {
            self.table.rows(row).select();
            self.state.refilter({
              selectedRows: selRows,
            });
          });
        }
      },
    });

    $("#tradesTbl tbody")
      .off()
      .on("click", "tr .addTag", function () {
        let row = self.table.row(this).data();
        if (!row.end) {
          return false;
        }
        self.table.rows().deselect();
        self.table.row(this).select();
        $("#addTagModal").modal("show");
      });

    this.table.on("select deselect", function (e, dt, type, indexes) {
      if (self.state.skipEvent) {
        self.setState({ skipEvent: false });
        return false;
      }
      let rows = self.table.rows({ selected: true }).data().toArray();
      if (!rows.map((x) => x.end).includes(null) && rows.length > 1) {
        //Disable trades without an end
        $("#addTagBtn").removeClass("d-none");
      } else {
        $("#addTagBtn").addClass("d-none");
      }
      if (rows.map((x) => x.end).includes(null)) {
        $("#activeTradeWarning").removeClass("d-none");
      } else {
        $("#activeTradeWarning").addClass("d-none");
      }
      let obj = {};
      if (!self.props.updateSymbols) {
        obj.skipUpdate = true;
      }
      self.setState(obj, function () {
        let obj = {
          selectedx0: rows.length === 1 && rows[0].start ? rows[0].start : null,
          selectedx1: rows.length === 1 && rows[0].end ? rows[0].end : null,
          selectedRows: rows,
        };
        if (!self.props.updateSymbols) {
          obj.selectedSybl = [...new Set(rows.map((x) => x.symbol))];
        }
        self.state.refilter(obj);
      });
    });
    this.setState({ needToUpdate: false });

    this.table
      .on("preDraw", function () {
        $(".popover").popover("dispose"); //doesn't seem to work on table element, so delete all
      })
      .on("draw.dt", function () {
        $("#tradesTbl").popover({
          selector: "td.symbolInfo",
          customClass: "symbolPopover",
          title: () => {
            return this.querySelector(".symbolInfo:hover").innerHTML;
          },
          html: true,
          content: () => {
            return `<div class="spinner-border" role="status">
						<span class="sr-only">Loading...</span>
					</div>`;
          },
          trigger: "hover",
          delay: { show: 300 },
        });
      });
    $("#tradesTbl").on("show.bs.popover", function () {
      let hoverElm = this.querySelector(".symbolInfo:hover");
      let sybl = hoverElm.innerHTML;
      self.symbolcontroller.abort();
      self.symbolcontroller = new AbortController();

      const apiClient = createApiClient();
      apiClient
        .post(
          MWBaseURL() + "symbol_info?" + GetParams(self.state),
          [
            {
              symbol: sybl.length > 15 ? sybl.slice(0, sybl.length - 15) : sybl,
              date: GetESTDateString(),
            },
          ],
          { signal: self.symbolcontroller.signal },
        )
        .then((data) => {
          let content = "N/A";
          if (data.length !== 0) {
            content = `<div>
					<div class="row"><div class="col text-nowrap"><b>Industry</b></div></div>
					<div class="row"><div class="col">${data[0].Industry}</div></div>
					<div class="row"><div class="col text-nowrap"><b>Subindustry</b></div></div>
					<div class="row"><div class="col">${data[0].Subindustry}</div></div>
					</div>`;
            $(hoverElm).data("bs.popover").config.title = data[0].Name;
          }
          $(hoverElm).data("bs.popover").config.content = content;
          $(hoverElm).data("bs.popover").setContent();
        })
        .catch((e) => console.log(e.message));
    });

    self.loadTagList();

    $("#addTagModal").on("shown.bs.modal", function () {
      $("#addTagModal #newTag").trigger("focus");
      self.setState({ newTag: "", newNote: "" });
      $("#dupErrorMsg").hide();
    });
    $("#addTagModal").on("show.bs.modal", function () {
      self.setState({ displayTagTbl: true });
    });
    $("#addTagModal").on("hidden.bs.modal", function () {
      self.setState({ displayTagTbl: false });
    });
  }

  tableRefresh = () => {
    this.table.ajax.reload(null, false);
    this.loadTagList();
  };

  tagTrade = (e) => {
    e.preventDefault();
    let self = this;
    let selectedTrades = !this.state.groupSymbols
      ? this.state.selectedRows
      : this.state.selectedRows.map((x) => x.trades).flat();
    if (
      !Array.from(selectedTrades, (x) => x.tags.map((y) => y.tag.toLowerCase()))
        .flat()
        .some((r) =>
          this.state.newTag
            .toLowerCase()
            .split(",")
            .map((x) => x.trim())
            .includes(r),
        ) &&
      this.state.newTag !== ""
    ) {
      let data = {
        tags: this.state.newTag.split(",").map((x) => x.trim()),
        user: this.state.auth.user,
        trades: [],
      };
      for (let i = 0; i < selectedTrades.length; i++) {
        let trd = {
          user: this.state.auth.user,
          notes: this.state.newNote,
          date: (selectedTrades[i].end || "").substring(0, 10),
          account:
            !this.state.acct[0] && this.state.auth.accounts.length === 1
              ? this.state.auth.accounts[0]
              : this.state.acct[0],
          symbol: selectedTrades[i].symbol,
          start: selectedTrades[i].start,
          end: selectedTrades[i].end,
          pnl: selectedTrades[i].pnl,
          shares: selectedTrades[i].shares,
        };
        data.trades.push(trd);
      }

      const apiClient = createApiClient();
      apiClient
        .post(MWBaseURL() + "tag_trades?", data)
        .then((result) => {
          $("#addTagModal").modal("hide");
          self.tableRefresh();
        })
        .catch((error) => {
          console.log("Error setting tag:", error);
        });
    }
  };

  tagTradeValid = (e) => {
    let selectedTrades = !this.state.groupSymbols
      ? this.state.selectedRows
      : this.state.selectedRows.map((x) => x.trades).flat();
    if (
      !Array.from(selectedTrades, (x) => x.tags.map((y) => y.tag.toLowerCase()))
        .flat()
        .some((r) =>
          this.state.newTag
            .toLowerCase()
            .split(",")
            .map((x) => x.trim())
            .includes(r),
        )
    ) {
      $("#dupErrorMsg").hide();
    } else {
      $("#dupErrorMsg").show();
    }
  };

  render() {
    return (
      <div>
        <div className="row justify-content-between pt-1">
          <h5 className="col-6" style={{ lineHeight: "1.5em" }}>
            Trades
          </h5>
          <div className="col-3">
            <button
              id="addTagBtn"
              type="button"
              className="d-none float-right btn btn-success"
              data-toggle="modal"
              data-target="#addTagModal"
            >
              Multi Tag
            </button>
            <span
              id="activeTradeWarning"
              className="d-none"
              title="Tagging active trades is not allowed."
              style={{ cursor: "pointer" }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="30"
                height="30"
                fill="currentColor"
                className="bi bi-exclamation-triangle text-warning float-right"
                viewBox="0 0 16 16"
              >
                <path d="M7.938 2.016A.13.13 0 0 1 8.002 2a.13.13 0 0 1 .063.016.146.146 0 0 1 .054.057l6.857 11.667c.036.06.035.124.002.183a.163.163 0 0 1-.054.06.116.116 0 0 1-.066.017H1.146a.115.115 0 0 1-.066-.017.163.163 0 0 1-.054-.06.176.176 0 0 1 .002-.183L7.884 2.073a.147.147 0 0 1 .054-.057zm1.044-.45a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566z" />
                <path d="M7.002 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 5.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995z" />
              </svg>
            </span>
          </div>
        </div>
        <table
          id="tradesTbl"
          className="display compact selectable"
          width="100%"
        ></table>
        <div
          className="modal fade"
          id="addTagModal"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="dailyActivitiesTblModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-lg" role="document">
            <div className="modal-content">
              {
                <div className="modal-header">
                  <h5 className="modal-title" id="dailyActivitiesTblModalLabel">
                    Add Tags
                  </h5>
                  <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
              }
              <div className="modal-body">
                {this.state.displayTagTbl &&
                  this.state.selectedRows &&
                  !Array.from(this.state.selectedRows, (x) => x.end).includes(
                    null,
                  ) && (
                    <TradeTagsTbl
                      selectedTrade={
                        !this.state.groupSymbols
                          ? this.state.selectedRows
                          : this.state.selectedRows.map((x) => x.trades).flat()
                      }
                      tradesRefresh={this.tableRefresh}
                    />
                  )}
                <form onSubmit={this.tagTrade}>
                  <h5 className="mt-4">
                    Add{" "}
                    <DisplayTimeRange
                      start={this.state.start}
                      end={this.state.end}
                      startTS={this.state.startTS}
                      endTS={this.state.endTS}
                    />
                  </h5>
                  <div
                    id="dupErrorMsg"
                    className="text-danger"
                    style={{ display: "none" }}
                  >
                    Duplicate Tag
                  </div>
                  <div className="input-group">
                    <div className="input-group-prepend">
                      <span className="input-group-text">
                        Tag&nbsp;
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          className="bi bi-info-circle"
                          viewBox="0 0 16 16"
                        >
                          <title>
                            Comma delimited list of tags. Whitespaces are
                            trimmed.
                          </title>
                          <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"></path>
                          <path d="M8.93 6.588l-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"></path>
                        </svg>
                      </span>
                    </div>
                    <Autocomplete
                      inputProps={{ className: "form-control", id: "newTag" }}
                      items={this.taglist}
                      shouldItemRender={(item, value) => {
                        return (
                          !Array.from(this.state.selectedRows, (x) =>
                            x.tags.map((y) => y.tag.toLowerCase()),
                          )
                            .flat()
                            .includes(item.tag.toLowerCase()) &&
                          item.tag.toLowerCase().includes(
                            value
                              .toLowerCase()
                              .split(",")
                              .map((x) => x.trim())
                              .slice(-1),
                          ) &&
                          !this.state.newTag
                            .split(",")
                            .map((x) => x.trim())
                            .slice(0, -1)
                            .includes(item.tag)
                        );
                      }}
                      getItemValue={(item) => item.tag}
                      renderItem={(item, highlighted) => (
                        <div
                          key={item.tag}
                          className={
                            highlighted
                              ? "dropdown-item active"
                              : "dropdown-item"
                          }
                        >
                          {item.tag}
                        </div>
                      )}
                      renderMenu={(children) => (
                        <div className="autocompleteMenu">{children}</div>
                      )}
                      value={this.state.newTag}
                      onChange={(e) => {
                        //max length 40 chars per tag
                        let newValue = e.target.value
                          .split(",")
                          .map((tag) => tag.slice(0, 40))
                          .join(",");
                        this.setState({ newTag: newValue }, function () {
                          this.tagTradeValid(e);
                        });
                      }}
                      onSelect={(value) =>
                        this.setState({
                          newTag:
                            this.state.newTag.slice(
                              0,
                              this.state.newTag.lastIndexOf(",") + 1,
                            ) + value,
                        })
                      }
                    />
                    <div className="input-group-prepend input-group-append">
                      <span className="input-group-text">Notes</span>
                    </div>
                    <textarea
                      id="newNote"
                      className="form-control"
                      maxLength="500"
                      autoComplete="off"
                      onChange={(e) =>
                        this.setState({ newNote: e.target.value })
                      }
                      value={this.state.newNote}
                      rows="1"
                    ></textarea>
                    <div className="input-group-append">
                      <button
                        type="submit"
                        className="input-group-text font-weight-bold text-success"
                        style={{ fontSize: "2rem", lineHeight: "1rem" }}
                      >
                        +
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default MultiDayTradesTbl;
